import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  templateName: {
    margin: '0 0.5rem',
    color: colors.neutral[900],
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
